/* eslint-disable */
export default {
  mute: 'Disatt. audio',
  unmute: 'Riattiva audio',
  hangup: 'Riaggancia',
  reject: 'Rifiuta',
} as const;

// @key: @#@"mute"@#@ @source: @#@"Mute"@#@
// @key: @#@"unmute"@#@ @source: @#@"Unmute"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hang up"@#@
// @key: @#@"reject"@#@ @source: @#@"Reject"@#@
